<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Bessern sich die Schmerzen durch Wärme und Entspannung oder durch Spazieren gehen?</p>
</QuestionFrame>
